<template>
  <div class="dialog">
    <div class='h100vh-197 w100vw-284 h-scroll'>
      <ejs-grid ref="gnbPmDataQueryList" :allowPaging="false" :dataSource="dataSourceOfGnbPmDataQuery" :columns='columnsOfGnbPmDataQuery' :allowResizing='true' :height="screenHeight" :width="screenWidth" :dataBound="dataBound"></ejs-grid>
    </div>
    <div>
      <ejs-pager ref='pagerOfGnbPmDataQueryList' @click="getGnbPmDataQueryListData" :currentPage='page.currentPage' :pageCount='page.pageCount' :pageSize='page.pageSize' :totalRecordsCount='page.totalRecordsCount'></ejs-pager>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ContentForGnbPmDataQueryRightList',
  props: [
    'dataLength'
  ],
  data() {
    return {
      dataSourceOfGnbPmDataQuery: [],
      columnsOfGnbPmDataQuery: [],
      screenHeight: 'calc(100vh - 236px)',
      screenWidth: '1462',
      page: {
        currentPage: 1,
        pageSize: 18,
        totalRecordsCount: 0,
        pageCount: 10
      },
    };
  },
  methods: {

    getGnbPmDataQueryListData(){
      this.$emit('gnbPmDataQueryListPageClick', this.$refs.pagerOfGnbPmDataQueryList.ej2Instances.currentPage);
    },

    dataBound() {
      let width = 820 + 300 * this.dataLength
      this.screenWidth = width < 1462 ? 1462 : width;
    },

    getColumnsOfGnbPmDataQuery(checkSystemNodeList, checkCustomNodeList){
      this.columnsOfGnbPmDataQuery = [];

      const columnsCacheOfOrdCommonAttr = [
        {
          field: 'resource_id',
          headerText: this.$t('Pm.resourceId'),
          textAlign: 'Center',
          clipMode: 'EllipsisWithTooltip',
          width: 100,
          autoFit: true
        },
        {
          field: 'start_time',
          headerText: this.$t('Pm.startTime'),
          textAlign: 'Center',
          clipMode: 'EllipsisWithTooltip',
          width: 150,
          autoFit: true,
          valueAccessor: function valueAccessor (field,data){
            return data[field].replace("T", " ").replace(/\+[0-9]{2}:[0-9]{2}$/g, '');
          }
        },
        {
          field: 'collect_cycle',
          headerText: this.$t('Pm.collectCycle'),
          textAlign: 'Center',
          clipMode: 'EllipsisWithTooltip',
          width: 100,
          autoFit: true,
          valueAccessor: function valueAccessor (field,data){
            const secondCycle = parseInt(data[field]) / 60;
            if(secondCycle < 60){
              return `${secondCycle}${this.$t('Pm.minutes')}`;
            } else if(secondCycle < 1440){
                return `${secondCycle / 60}${this.$t('Pm.hours')}`;
            } else{
                return `${secondCycle / 60 / 24}${this.$t('Pm.days')}`;
            }

          }
        },
        {
          field: 'subnet_work',
          headerText: this.$t('Pm.subnetWork'),
          textAlign: 'Center',
          clipMode: 'EllipsisWithTooltip',
          width: 100,
          autoFit: true
        },
        {
          field: 'managed_element',
          headerText: this.$t('Pm.managedElement'),
          textAlign: 'Center',
          clipMode: 'EllipsisWithTooltip',
          width: 100,
          autoFit: true
        },
        {
          field: 'meas_obj_ldn',
          headerText: this.$t('Pm.measObjLdn'),
          textAlign: 'Center',
          clipMode: 'EllipsisWithTooltip',
          width: 200,
          autoFit: true
        }
      ]

      let columnsCacheOfSystemCounter = checkSystemNodeList.map(function (checkNode) {
        return {
          field: checkNode.id,
          headerText: checkNode.text,
          textAlign: 'Center',
          clipMode: 'EllipsisWithTooltip',
          width: 300,
          valueAccessor: function valueAccessor (field,data){
            return data[field] == undefined || data[field] == null || data[field].toString() == '' ? '—' : data[field];
          },
          autoFit: true
        }
      })

      let columnsCacheOfCustomCounter = checkCustomNodeList.map(function (checkNode) {
        return {
          field: checkNode.id,
          headerText: checkNode.text,
          textAlign: 'Center',
          clipMode: 'EllipsisWithTooltip',
          width: 300,
          valueAccessor: function valueAccessor (field,data){
            return data[field] == undefined || data[field] == null || data[field].toString() == '' ? '—' : data[field];
          },
          autoFit: true
        }
      })

      for (let k = 0; k < columnsCacheOfOrdCommonAttr.length; k++) {
        this.columnsOfGnbPmDataQuery.push(columnsCacheOfOrdCommonAttr[k]);
      }

      for (let k = 0; k < columnsCacheOfSystemCounter.length; k++) {
        this.columnsOfGnbPmDataQuery.push(columnsCacheOfSystemCounter[k]);
      }

      for (let k = 0; k < columnsCacheOfCustomCounter.length; k++) {
        this.columnsOfGnbPmDataQuery.push(columnsCacheOfCustomCounter[k]);
      }
    },
    timeFormatter(){

    }
  },
  mounted() {
  }
};
</script>

<style scoped>
  .dialog >>> .e-control.e-grid .e-gridcontent.e-lib.e-droppable {
    height: calc(100vh - 239px);
  }
</style>
